import TasksAPI from 'dashboard/api/tasks';
import { types } from './mutations';

export default {
  // troca rápida de filtro/período dispara múltiplos fetches em paralelo
  // (Index.vue, TaskWeekView.vue, TaskCalendarView.vue); como as respostas
  // podem chegar fora de ordem, só aplica o commit se ainda for a
  // requisição mais recente (evita sobrescrever a lista com dados obsoletos).
  async fetchTasks({ commit, state }, filters = {}) {
    commit(types.BUMP_FETCH_TASKS_REQUEST_ID);
    const requestId = state.fetchTasksRequestId;
    commit(types.SET_UI_FLAG, { isLoading: true });
    try {
      const { data } = await TasksAPI.list(filters);
      if (requestId === state.fetchTasksRequestId) {
        commit(types.SET_TASKS, data.data);
      }
    } finally {
      if (requestId === state.fetchTasksRequestId) {
        commit(types.SET_UI_FLAG, { isLoading: false });
      }
    }
  },

  async fetchTask({ commit }, taskId) {
    const { data } = await TasksAPI.show(taskId);
    commit(types.SET_TASK, data);
    return data;
  },

  async createTask({ commit }, taskData) {
    try {
      const { data } = await TasksAPI.create(taskData);
      commit(types.ADD_TASK, data);
      return { success: true, data };
    } catch (error) {
      const errors = error.response?.data?.errors ?? ['Error creating task'];
      return { success: false, errors };
    }
  },

  async updateTask({ commit }, { taskId, ...taskData }) {
    try {
      const { data } = await TasksAPI.update(taskId, taskData);
      commit(types.UPDATE_TASK, data);
      return { success: true, data };
    } catch (error) {
      const errors = error.response?.data?.errors ?? ['Error updating task'];
      return { success: false, errors };
    }
  },

  async deleteTask({ commit }, taskId) {
    await TasksAPI.destroy(taskId);
    commit(types.REMOVE_TASK, taskId);
  },

  async completeTask({ dispatch }, taskId) {
    return dispatch('updateTask', {
      taskId,
      status: 'completed',
      completed_at: new Date().toISOString(),
    });
  },

  async fetchComments({ commit }, taskId) {
    const { data } = await TasksAPI.listComments(taskId);
    commit(types.SET_COMMENTS, data.data);
  },

  async createComment({ commit }, { taskId, content }) {
    const { data } = await TasksAPI.createComment(taskId, content);
    commit(types.ADD_COMMENT, data);
    return data;
  },

  async deleteComment({ commit }, { taskId, commentId }) {
    await TasksAPI.destroyComment(taskId, commentId);
    commit(types.REMOVE_COMMENT, commentId);
  },

  async bulkUpdateTasks({ commit }, { ids, data }) {
    const { data: responseData } = await TasksAPI.bulkUpdate(ids, data);
    commit(types.BULK_UPDATE_TASKS, responseData.data ?? responseData);
  },

  async bulkDeleteTasks({ commit }, ids) {
    await TasksAPI.bulkDestroy(ids);
    commit(types.REMOVE_TASKS, ids);
  },

  async bulkLabelAddTasks({ commit }, { ids, label }) {
    const { data: responseData } = await TasksAPI.bulkLabelAdd(ids, label);
    commit(types.BULK_UPDATE_TASKS, responseData.data ?? responseData);
  },

  async bulkLabelRemoveTasks({ commit }, { ids, label }) {
    const { data: responseData } = await TasksAPI.bulkLabelRemove(ids, label);
    commit(types.BULK_UPDATE_TASKS, responseData.data ?? responseData);
  },

  async bulkLabelRemoveAllTasks({ commit }, ids) {
    const { data: responseData } = await TasksAPI.bulkLabelRemoveAll(ids);
    commit(types.BULK_UPDATE_TASKS, responseData.data ?? responseData);
  },
};
